import Listgrid from './listgrid.vue';
export default Listgrid;


// WEBPACK FOOTER //
// ./src/components/listgrid/index.js